import type { LocalStorageKeys } from "./strings.utils";
const localStorageEnalbed = () => {
  let storage: Storage;
  try {
    storage = (window as any)["localStorage"];
    const x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (_) {
    return false;
  }
};
export const loadState = (key: LocalStorageKeys) => {
  if (!localStorageEnalbed()) return undefined;
  try {
    const serializedState = localStorage.getItem(key.toString());
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (key: LocalStorageKeys, state: any) => {
  if (!localStorageEnalbed()) return;
  const serializedState = JSON.stringify(state);
  localStorage.setItem(key.toString(), serializedState);
};

export const clearState = (key: LocalStorageKeys) => {
  if (!localStorageEnalbed()) return;
  localStorage.removeItem(key.toString());
};

export default { loadState, saveState, clearState };
